import toast from 'react-hot-toast';

export const notifyError = (errorMessage = 'Coś poszło nie tak. Spróbuj później.') =>
    toast.error(errorMessage, {
        duration: 3000,
    });
